import { render, staticRenderFns } from "./AscentGymEditForm.vue?vue&type=template&id=0b6ee9f2"
import script from "./AscentGymEditForm.vue?vue&type=script&lang=js"
export * from "./AscentGymEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports